import { axiosHyperwolfClient } from "axiosClient";
import { axiosHyperwolfDevClient } from "axiosClient";
import { getQueryString } from "utilities/common";

export function getAllProductsAPI(data) {
  const {
    limit = 10,
    skip = 0,
    searchTerm,
    categoryId,
    productTags,
    brandId,
    active,
    minPrice,
    maxPrice,
    sellType,
    sortBy,
    order = 'asc',
  } = data || {};
  const newData = { limit, skip };
  if (searchTerm != null && searchTerm !== '') newData.searchTerm = searchTerm;
  if (categoryId != null && categoryId !== '') newData.categoryId = categoryId;
  if (productTags != null && productTags !== '') newData.productTags = productTags;
  if (brandId != null && brandId !== '') newData.brandId = brandId;
  if (active !== undefined && active !== '') newData.active = active === true || active === 'true';
  if (minPrice != null && minPrice !== '') newData.minPrice = Number(minPrice);
  if (maxPrice != null && maxPrice !== '') newData.maxPrice = Number(maxPrice);
  if (sellType != null && sellType !== '') newData.sellType = sellType;
  if (sortBy != null && sortBy !== '') newData.sortBy = sortBy;
  if (order != null && order !== '') newData.order = order;
  return axiosHyperwolfDevClient.get(`api/v1/listing/products/data?${getQueryString(newData)}`);
}

export function getSingleProductDetailsAPI(data) {
  return axiosHyperwolfClient.get(`api/v1/admin/products/${data}`);
}

/** Get product details for edit form – uses dev URL, api/v1/product/:productId */
export function getProductDetailsForEditAPI(productId) {
  return axiosHyperwolfDevClient.get(`api/v1/product/${productId}`);
}

export function createProductAPI(data) {
  return axiosHyperwolfDevClient.post("api/v1/admin/products", data);
}

export function getInfoAndEffectAPI(data) {
  return axiosHyperwolfClient.get(`api/v1/admin/products/infoEffects`);
}

export function updateSingleProductAPI(id, data) {
  return axiosHyperwolfDevClient.put(`api/v1/admin/products/${id}`, data);
}

export function addCategoryAPI(data, id) {
  if (id) {
    return axiosHyperwolfClient.put(`api/v1/admin/category/${id}`, data);
  }
  return axiosHyperwolfClient.post(`api/v1/admin/category`, data);
}


export function getAllCategoryAPI(data) {
  const queryParams = new URLSearchParams(data);
  return axiosHyperwolfClient.get(`api/v1/admin/category?${queryParams.toString()}`);
}


export function updateCategoriesAPI(data) {
  return axiosHyperwolfClient.post(`api/v1/admin/category/multi`, data);
}

export function deleteCategoryAPI(id) {
  return axiosHyperwolfClient.delete(`api/v1/admin/category/${id}`);
}


export function getAllBlazeCategoryAPI(data) {
  return axiosHyperwolfClient.get(`api/v1/admin/category/blaze`, data);
}

export function getAllCategoryImagesAPI(data) {
  return axiosHyperwolfClient.get(`api/v1/admin/category/images`, data);
}

export function getAllBrandsByProductAPI() {
  return axiosHyperwolfClient.get(`api/v1/admin/products/brand/blaze`);
}

export function getAllBmwBrandsAPI() {
  return axiosHyperwolfClient.get(`api/v1/admin/products/brand`);
}

export function addBrandToBmwAPI(data) {
  return axiosHyperwolfClient.post(`api/v1/admin/products/brand`, data);
}

export function updateBrandFromBmwAPI(data) {
  return axiosHyperwolfClient.put(`api/v1/admin/products/brand`, data);
}

export function deleteBrandFromBmwAPI(id) {
  return axiosHyperwolfClient.delete(`api/v1/admin/products/brand/${id}`);
}

export function syncProductAdminAPI() {
  return axiosHyperwolfClient.post(`api/v1/admin/products/syncProducts`);
}

// Threshold API
export function getThresholdAdminAPI(data) {
  return axiosHyperwolfClient.get(`api/v1/admin/product/threshold`, data);
}

export function updateThresholdAPI(data) {
  return axiosHyperwolfClient.put(`api/v1/admin/update/product/threshold`, data);
}



export async function updateProductTraitAPI(data) {
  return await axiosHyperwolfClient.put(`api/v1/product/trait/update`, data)
}


export async function fetchProductDetailsAPI(productId) {
  return await axiosHyperwolfClient.get(`/api/v1/product/${productId}`);
}


export async function fetchProductTraitsAPI(id, filters) {
  return await axiosHyperwolfClient.get(`api/v1/product/trait/details/${id}?${getQueryString(filters)}`)
}


export async function fetchIndividualProductTraitAPI(productId, traitId) {
  return await axiosHyperwolfClient.get(`api/v1/product/trait/individual/details?productId=${productId}&traitId=${traitId}`)
}


export async function createProductTraitAPI(data) {
  return await axiosHyperwolfClient.post('api/v1/product/trait/assignment', data)
}

export async function deleteProductTraitAPI(productId, productTraitId) {
  return await axiosHyperwolfClient.delete(`api/v1/product/trait/delete/${productId}/${productTraitId}`)
}


export async function addProductStrainAPI(data) {
  return await axiosHyperwolfClient.post('api/v1/product/trait/assign/multiple/strains', data)
}

export async function deleteProductStrainAPI(productId, subStrainSlug) {
  return await axiosHyperwolfClient.delete(`api/v1/product/delete/matched/strains?productId=${productId}&subStrainSlug=${subStrainSlug}`)
}


export function getCategoryDataAPI(data) {
  return axiosHyperwolfClient.get(`api/v1/admin/category/${data}`,);
}

// Product tags listing (with search)
export function fetchProductTagsListingAPI(params = {}) {
  const query = getQueryString(params);
  return axiosHyperwolfDevClient.get(`api/v1/fetch/product/tags/listing${query ? `?${query}` : ""}`);
}

// Create product tag (on Enter in Add Product)
export function createProductTagAPI(data) {
  return axiosHyperwolfDevClient.post("api/v1/product/tags", data);
}